import { officeV } from '../../domainServices/OfficesService';
import { fetchWrapper } from '../fetchWrapper';

export function getOffice(id: string) {
  return fetchWrapper({ url: `/api/office/${id}`, dataType: officeV });
}
